import { useLanguage } from '../contexts/LanguageContext'
import { GeorgiaFlag, UKFlag } from './Flags'

type LanguageToggleProps = {
  className?: string
  value?: string
  onChange?: (lang: string) => void
}

const OPTIONS = [
  { code: 'ka', label: 'ქართული', short: 'KA', Flag: GeorgiaFlag },
  { code: 'en', label: 'English', short: 'EN', Flag: UKFlag },
] as const

const LanguageToggle = ({ className = '', value, onChange }: LanguageToggleProps) => {
  const ctx = useLanguage()
  const language = value ?? ctx.language
  const setLanguage = onChange ?? ctx.setLanguage

  return (
    <div
      className={`inline-flex w-fit items-center rounded-full bg-white p-0.5 shadow-celebrate-sm dark:bg-[#1e1438] ${className}`.trim()}
      data-testid="language-toggle"
      role="group"
      aria-label="Language"
    >
      {OPTIONS.map(({ code, label, Flag }) => {
        const active = language === code
        return (
          <button
            key={code}
            type="button"
            onClick={() => setLanguage(code)}
            title={label}
            aria-label={label}
            aria-pressed={active}
            className={`flex items-center justify-center rounded-full p-1.5 transition-all duration-200 motion-reduce:transition-none ${
              active
                ? 'bg-grad-hot shadow-[0_4px_10px_rgba(255,77,141,0.35)]'
                : 'opacity-55 hover:opacity-100'
            }`}
          >
            <Flag className="h-4 w-[1.45rem] rounded-[3px] shadow-[0_0_0_1px_rgba(0,0,0,0.06)]" title={label} />
            <span className="sr-only">{label}</span>
          </button>
        )
      })}
    </div>
  )
}

export default LanguageToggle
